import React, { useEffect, useMemo, useState } from 'react'

import AddIcon from '@mui/icons-material/Add'
import RemoveIcon from '@mui/icons-material/Remove'

import {
  NumberSelectorIconButton,
  NumberSelectorIconButtonWrapper,
  NumberSelectorLabel,
  NumberSelectorValue,
  NumberSelectorWrapper,
} from './index.styles'

interface NumberSelectorProps {
  selectorLabel?: string
  minValue?: number
  maxValue?: number
  currentValue?: number
  step?: number
  handleValueChange?: (selectedValue: number) => void
}
const NumberSelector = (props: NumberSelectorProps) => {
  const { selectorLabel, minValue, maxValue, currentValue, handleValueChange, step = 1 } = props

  const [selectedValue, setSelectedValue] = useState(currentValue ?? (minValue || 0))
  const isDecreaseButtonDisabled = useMemo(
    () => (typeof minValue === 'number' ? selectedValue - step < minValue : false),
    [[minValue, selectedValue]],
  )
  const isIncreaseButtonDisabled = useMemo(
    () => (typeof maxValue === 'number' ? selectedValue + step > maxValue : false),
    [[selectedValue, maxValue]],
  )

  useEffect(() => {
    if (typeof currentValue === 'number') {
      setSelectedValue(currentValue)
    }
  }, [currentValue])

  const handleIncrement = () => {
    setSelectedValue(selectedValue + step)
    handleValueChange?.(selectedValue + step)
  }
  const handleDecrement = () => {
    setSelectedValue(selectedValue - step)
    handleValueChange?.(selectedValue - step)
  }

  return (
    <NumberSelectorWrapper data-testid="number-selector">
      {selectorLabel && <NumberSelectorLabel>{selectorLabel}</NumberSelectorLabel>}
      <NumberSelectorIconButtonWrapper>
        <NumberSelectorIconButton disableRipple onClick={handleDecrement} disabled={isDecreaseButtonDisabled}>
          <RemoveIcon />
        </NumberSelectorIconButton>
      </NumberSelectorIconButtonWrapper>
      <NumberSelectorValue data-testid="number-selector-value">{selectedValue}</NumberSelectorValue>
      <NumberSelectorIconButtonWrapper>
        <NumberSelectorIconButton disableRipple onClick={handleIncrement} disabled={isIncreaseButtonDisabled}>
          <AddIcon />
        </NumberSelectorIconButton>
      </NumberSelectorIconButtonWrapper>
    </NumberSelectorWrapper>
  )
}

export default NumberSelector
